import { render, staticRenderFns } from "./EmptyExamResult.vue?vue&type=template&id=4164e054&"
import script from "./EmptyExamResult.vue?vue&type=script&lang=js&"
export * from "./EmptyExamResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports